import React from "react";
import { useParams } from "react-router-dom";
import { EvtHeader } from "components/header";
import { useFetch } from "@/hooks/useFetch";
import { fetchExtension } from "@/modules/work/jobs/extensions/read";
import ExtensionForm from "@/modules/work/jobs/extensions/form";
import Loader from "@/components/loader";
import ErrorState from "@/components/states/error";
import { StatusDisplay } from "@/components/status/display";

export default function UpdateExtension() {
  const { jobId, extensionId } = useParams();

  const { data: extension, isLoading, error } = useFetch({
    queryKey: ["job_extensions", extensionId],
    queryFn: () => fetchExtension({ id: extensionId }),
  });

  if (isLoading) return <Loader />;
  if (error) return <ErrorState title="Error loading extension" message={error?.message} />;
  if (!extension) return null;

  return (
    <div className="flex-1">
      <EvtHeader title="Edit Extension" description={<StatusDisplay value={extension?.status} />} />
      <div className="p-6 max-w-md">
        <ExtensionForm
          jobId={jobId}
          extensionId={extensionId}
          defaultValues={extension}
        />
      </div>
    </div>
  );
}
